import React from "react";
import { ArrowUpRight } from "lucide-react";

function scrollTo(hash) {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -60, duration: 1.2 });
  else el.scrollIntoView({ behavior: "smooth" });
}

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="relative bg-[#1A1A1A] text-white pt-20 md:pt-28 pb-10 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Brand + big statement */}
          <div className="md:col-span-8">
            <img
              src="/three-balls-logo-white.webp"
              alt="Three Balls"
              className="h-8 md:h-10 w-auto select-none pointer-events-none"
              draggable={false}
            />

            <h3 className="mt-8 font-display font-black tracking-tighter text-5xl sm:text-6xl md:text-[88px] md:leading-[0.92] leading-[0.95]">
              Hong Kong-based.{" "}
              <span className="text-[#FFE600]">World-ready.</span>
            </h3>
            <p className="mt-6 max-w-xl text-lg text-white/70 leading-relaxed">
              Making the web friendlier for businesses everywhere.
            </p>

            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollTo("#contact"); }}
              className="mt-10 inline-flex items-center gap-3 pl-6 pr-1.5 py-1.5 rounded-full bg-[#E9298A] hover:bg-white hover:text-[#1A1A1A] text-white font-semibold text-base transition-colors duration-300 group"
            >
              Start a project
              <span className="w-9 h-9 rounded-full bg-white text-[#1A1A1A] flex items-center justify-center group-hover:rotate-45 transition-transform duration-300">
                <ArrowUpRight className="w-4 h-4" />
              </span>
            </a>
          </div>

          {/* Links */}
          <div className="md:col-span-4 grid grid-cols-2 gap-6 md:pt-2">
            <div>
              <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/50">
                Menu
              </div>
              <ul className="mt-4 space-y-2 text-sm">
                {[
                  ["Home", "#home"],
                  ["Services", "#services"],
                  ["Projects", "#projects"],
                  ["About", "#about"],
                  ["Contact", "#contact"],
                ].map(([l, h]) => (
                  <li key={l}>
                    <a
                      href={h}
                      onClick={(e) => { e.preventDefault(); scrollTo(h); }}
                      className="hover:text-[#FFE600] transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <div className="font-mono text-[10px] tracking-[0.22em] uppercase text-white/50">
                Reach
              </div>
              <ul className="mt-4 space-y-2 text-sm">
                <li>
                  <a href="mailto:info@threeballs.digital" className="hover:text-[#FFE600] transition-colors">
                    info@threeballs.digital
                  </a>
                </li>
                <li className="text-white/60">Hong Kong · Remote friendly</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-16 md:mt-24 pt-6 border-t border-white/10 flex flex-col md:flex-row md:items-center justify-between gap-4 text-xs text-white/50 font-mono uppercase tracking-widest">
          <div>© {year} Three Balls · threeballs.digital</div>
          <div className="flex items-center gap-2">
            <span className="w-2 h-2 rounded-full bg-[#FFE600] animate-pulse" />
            <span>Made in Hong Kong</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
